import { MergeIntegrationTypeState } from './merge-integration-selectors';
import { FAILURE, STARTING, SUCCESS } from '../action/util/action-name-creators';
import { Action, updateResourceByObjectKey } from '../reducers/utils/state-manager';

const InitialState = {
  mergeIntegrationsByOrgId: {},
  mergeIntegrationsStateByOrgId: {},
  mergeSyncHealthByOrgId: {},
  mergeSyncHealthStateByOrgId: {},
};

export const mergeIntegrationsReducer = (
  state: MergeIntegrationTypeState = InitialState,
  action: Action,
) => {
  switch (action.type) {
    case STARTING('CREATE_MERGE_INTEGRATION'):
    case STARTING('UPDATE_MERGE_INTEGRATION'):
    case STARTING('LOAD_MERGE_INTEGRATION'):
    case STARTING('DELETE_MERGE_INTEGRATION'): {
      const {
        payload: {
          args: { orgId },
        },
      } = action;
      return updateResourceByObjectKey(state, 'mergeIntegrationsByOrgId', orgId, true);
    }
    case SUCCESS('CREATE_MERGE_INTEGRATION'):
    case SUCCESS('UPDATE_MERGE_INTEGRATION'):
    case SUCCESS('LOAD_MERGE_INTEGRATION'): {
      const {
        payload: {
          args: { orgId },
          data,
        },
      } = action;
      return updateResourceByObjectKey(state, 'mergeIntegrationsByOrgId', orgId, false, {
        [orgId]: data || undefined,
      });
    }
    case FAILURE('CREATE_MERGE_INTEGRATION'):
    case FAILURE('UPDATE_MERGE_INTEGRATION'):
    case FAILURE('LOAD_MERGE_INTEGRATION'):
    case FAILURE('DELETE_MERGE_INTEGRATION'): {
      const {
        payload: {
          args: { orgId },
        },
      } = action;
      return updateResourceByObjectKey(state, 'mergeIntegrationsByOrgId', orgId, false);
    }
    case SUCCESS('DELETE_MERGE_INTEGRATION'): {
      const {
        payload: {
          args: { orgId },
        },
      } = action;

      return updateResourceByObjectKey(state, 'mergeIntegrationsByOrgId', orgId, orgId);
    }
    case STARTING('LOAD_MERGE_SYNC_HEALTH'): {
      const {
        payload: {
          args: { orgId },
        },
      } = action;
      return updateResourceByObjectKey(state, 'mergeSyncHealthByOrgId', orgId, true);
    }
    case SUCCESS('LOAD_MERGE_SYNC_HEALTH'): {
      const {
        payload: {
          args: { orgId },
          data,
        },
      } = action;
      return data
        ? updateResourceByObjectKey(state, 'mergeSyncHealthByOrgId', orgId, false, {
            [orgId]: data,
          })
        : state;
    }
    case FAILURE('LOAD_MERGE_SYNC_HEALTH'): {
      const {
        payload: {
          args: { orgId },
        },
      } = action;
      return updateResourceByObjectKey(state, 'mergeSyncHealthByOrgId', orgId, false);
    }
    default:
      return state;
  }
};
